import { loadStripe } from "@stripe/stripe-js";

const devKey = "pk_test_oc1X4vOAoWwGywHzx9JbEgdc00so2R5RXg";
const prodKey = "pk_live_VSkG8hvaKCtqQAqG1yVe3Qrf007LexkoZG";

let striptInstance = null;

export const stripeKey = (() => {
  const approot = document.getElementById("app");
  if (approot) {
    return approot.dataset.useProdStripeKey === "true" ? prodKey : devKey;
  }
})();

export function initStripe() {

  let key = stripeKey;
  return loadStripe(key).then((stripe) => {
    striptInstance = stripe;
    return stripe;
  });
}

export function getStripe() {
  return striptInstance;
}
